(function($) {
  'use strict';

  if ($('html').hasClass('page-home-page')) {

    var index = {
      dom: function() {
        this.$header             = $('#header');
        this.$hero               = $('#hero');
        this.$heroMedia          = $('#heroMedia');
        this.$heroRotator        = $('#heroRotator');
        this.$heroVideo          = $('heroVideo');
        this.$additionalCarousel = $('#additionalCarousel');
        this.$featuredCarousel   = $('#featuredCarousel');
        this.$reviewsRotator     = $('#reviewsRotator');
      },

      settings: {
        heroLayout      : jcms.home_settings.hero_layout,
        heroSizing      : jcms.home_settings.hero_sizing,
        rotatorAutoplay : jcms.home_settings.hero_rotator_autoplay,
        rotatorSpeed    : jcms.home_settings.hero_rotator_speed ? jcms.home_settings.hero_rotator_speed * 1000 : 7000,
        rotatorNav      : jcms.home_settings.hero_rotator_nav,
      },

      hero: function() {
        if ((this.settings.heroLayout == 2 || this.settings.heroLayout == 3) && this.settings.heroSizing != 1) {
          var $target = this.settings.heroLayout == 2 ? this.$hero : this.$heroMedia;
          if ($target) {
            if ($(window).width() <= jcms.breakpoints.fluid && this.settings.heroSizing == 3) {
              $target.css('min-height', 0);
            }
            else {
              $target.css('min-height', $(window).height());
            }
          }
        }
        else if (this.settings.heroSizing == 1 && event.type != 'scroll') {
          this.$heroMedia.css('padding-top', this.$header.outerHeight());
        }
      },

      heroRotator: function() {
        var controlNav = index.settings.rotatorNav == 'control' ? true : false;
        var directionNav = index.settings.rotatorNav == 'direction' ? true : false;
        this.$heroRotator.flexslider({
          selector: '.homepage__hero-gallery-item',
          directionNav: directionNav,
          controlNav: controlNav,
          slideshow: index.settings.rotatorAutoplay,
          slideshowSpeed: index.settings.rotatorSpeed,
          start : function(slider) {
            if (slider.count < 2) {
              if (slider.directionNav) {
                $('.' + slider.vars.namespace + 'direction-nav', slider[0]).remove();
              }
              if (slider.controlNav) {
                $('.' + slider.vars.namespace + 'control-nav', slider[0]).remove();
              }
            }
            else {
              if (slider.directionNav) {
                var $directionNav = $('.' + slider.vars.namespace + 'direction-nav', slider[0]);
                var $li = $directionNav.find('li');
                var $a = $directionNav.find('a');
                // $li.addClass('palette-primary');
                $a.each(function() {
                  $(this).attr('aria-label', $(this).text());
                });
                $a.first().html('<span class="icon icon-arrow-left"></span>');
                $a.last().html('<span class="icon icon-arrow-right"></span>');
              }
            }
          }
        });
      },

      heroVideo: function() {
        var self = this;

        self.$heroVideo.each(function() {
          var video = $(this)[0];
          var id = $(this).attr('id');
          var $fallback = $(this).next('img');
          var loop = 0;

          if ($(this).attr('data-src') && !$(this).attr('src')) {
            $(this).attr('src', $(this).data('src'));
            $(this).removeAttr('data-src').attr('preload','none');
            video.load();
          }

          Modernizr.on('videoautoplay', function(result) {
            if (!result) {
              if ('playsInline' in document.createElement(id)) {
                return false;
              }
              else {
                if (video.play() === undefined) {
                  video.pause();
                  video.remove();
                  $fallback.show();
                }
              }

              var checkVideo = setInterval(function() {
                if (video.readyState === 4) {
                  clearInterval(checkVideo);
                }
                else if (++loop >= 3) {
                  $fallback.attr('src', $fallback.data('src')).show();
                  video.pause();
                  video.removeAttribute('src');
                  video.remove();
                  clearInterval(checkVideo);
                }
              }, 1000);
            }
          });
        });
      },

      additionalCarousel: function() {
        if ($(window).width() > jcms.breakpoints.fluid_medium) {
          if (!index.$additionalCarousel.hasClass('owl-carousel')) {
            index.$additionalCarousel.addClass('owl-carousel owl-theme').owlCarousel({
              dots: false,
              nav: true,
              loop: true,
              margin: 40,
              mouseDrag: false,
              smartSpeed: 1000,
              responsive: {
                0: {
                  items: 1,
                  dots: true,
                },
                620: {
                  items: 2,
                  dots: true,
                  nav: false
                },
                809: {
                  margin: 60,
                  items: 3
                }
              },
              onInitialized: function(event) {
                var index = event.item.index;
                var last = Math.floor(event.page.size);
                $('.owl-item', index.$additionalCarousel).eq(index + last).addClass('sliding');
              },
              onTranslate: function(event) {
                var index = event.item.index;
                var last = Math.floor(event.page.size);
                $('.owl-item', index.$additionalCarousel).eq(index + last - 1).removeClass('sliding');
                $('.owl-item', index.$additionalCarousel).eq(index + last).addClass('sliding');
                $('.owl-item', index.$additionalCarousel).eq(index - 1).addClass('sliding');
              },
              onTranslated: function(event) {
                var index = event.item.index;
                var last = Math.floor(event.page.size);
                $('.owl-item', index.$additionalCarousel).removeClass('sliding');
                $('.owl-item', index.$additionalCarousel).eq(index + last).addClass('sliding');
              }
            });
          }
        }
        else {
          index.$additionalCarousel.removeClass('owl-carousel owl-theme').trigger('destroy.owl.carousel');
        }
      },

      featuredCarousel: function() {
        var $this = this.$featuredCarousel;
        $this.slick({
          infinite: true,
          dots: false,
          arrows: true,
          responsive: [
            {
              breakpoint: jcms.breakpoints.fluid,
              settings: {
                arrows: false,
                dots: true
              }
            },
          ]
        });
      },

      reviewsRotator: function() {
        this.$reviewsRotator.each(function() {
          var $this = $(this);

          $this.on('init', function(event, slick){
            if (slick.$nextArrow && slick.$prevArrow) {
              slick.$nextArrow.addClass('transparent');
              slick.$prevArrow.addClass('transparent');
            }
          });

          $this.slick({
            infinite: true,
            dots: false,
            arrows: true,
            responsive: [
              {
                breakpoint: jcms.breakpoints.fluid,
                settings: {
                  dots: true,
                  arrows: false
                }
              },
            ]
          });
        });
      },

      ready: function() {
        this.dom();
        this.heroRotator();
        this.heroVideo();
        this.featuredCarousel();
        this.reviewsRotator();
      }
    };

    $(function() { index.ready(); });

    $(window).on('load resize scroll', function(event) {
      index.hero();

      if (event.type != 'scroll') {
        setTimeout(function() {
          index.additionalCarousel();
        }, 500);
      }
    });

  }

})(jQuery);
